export const messages = {
  en: {
    marketGoodsItem: {
      search: {
        title: 'Search Conditions',
        prodName: 'Please enter product name'
      },
      list: {
        title: 'Marketing Products'
      },
      table: {
        picUrl: 'Image',
        prodName: 'Product Name',
        prodDesc: 'Product Description',
        picLink: 'Access URL',
        price: 'Price',
        shopName: 'Shop Name',
        sort: 'Sort'
      },
      fetchError: 'Failed to get marketing products'
    }
  },
  zh: {
    marketGoodsItem: {
      search: {
        title: '查询条件',
        prodName: '请输入商品名称'
      },
      list: {
        title: '营销商品'
      },
      table: {
        picUrl: '图片',
        prodName: '商品名称',
        prodDesc: '商品简介',
        picLink: '访问地址',
        price: '金额(元)',
        shopName: '商铺名称',
        sort: '排序'
      },
      fetchError: '获取营销商品失败'
    }
  }
}